import { Instagram, Linkedin } from '../../components/icons/BrandIcons';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import ContactInfo from '../../components/ContactInfo';
import ThemeToggle from '../../components/ThemeToggle';
import routes from '../../config/routes';
import Logo from '../../img/logo.png';

const FOCUS_RING =
  'focus-visible:outline-2 focus-visible:outline-white focus-visible:outline-offset-2 rounded-sm';

const Footer = () => {
  const { t } = useTranslation();

  return (
    <footer className="w-full bg-[#101521] text-white pt-8">
      <div className="max-w-screen-xl mx-auto px-4 sm:px-6 lg:px-10">
        <div className="flex items-center justify-between gap-4 pb-6">
          <Link
            to={routes.homeRoute.path}
            className={`flex items-center gap-2.5 shrink-0 ${FOCUS_RING}`}
          >
            <img src={Logo} alt="INDUSTRIAS TELME" className="h-8" />
            <span className="font-extrabold text-lg tracking-wide">TELME</span>
          </Link>
          <div className="flex items-center gap-2">
            <a
              href="https://www.linkedin.com/company/industrias-telme-saicfi"
              target="_blank"
              rel="noreferrer"
              aria-label="LinkedIn"
              className={`p-2 rounded-md border border-white/40 hover:bg-white/10 transition-colors ${FOCUS_RING}`}
            >
              <Linkedin size={18} />
            </a>
            <a
              href="https://www.instagram.com/industrias.telme/"
              target="_blank"
              rel="noreferrer"
              aria-label="Instagram"
              className={`p-2 rounded-md border border-white/40 hover:bg-white/10 transition-colors ${FOCUS_RING}`}
            >
              <Instagram size={18} />
            </a>
          </div>
        </div>

        <div className="border-t border-white/15" />

        <ContactInfo className="flex flex-col sm:flex-row sm:flex-wrap gap-6 py-6 text-white/70 [&_p]:text-white" />

        <div className="border-t border-white/15" />

        <div className="flex flex-col sm:flex-row items-center justify-between gap-3 py-4 text-center sm:text-left">
          <div className="flex items-center gap-3">
            <ThemeToggle />
            <span className="text-sm text-white/60">{t('layout.footer.copyright')}</span>
          </div>
          <div className="flex items-center gap-5">
            <Link
              to="/privacy-policy"
              className={`text-sm underline underline-offset-2 hover:opacity-80 ${FOCUS_RING}`}
            >
              {t('router.privacy-policy')}
            </Link>
            <Link
              to={routes.publicRoutes.contactUs.path}
              className={`bg-secondary hover:bg-secondary-hover text-secondary-foreground text-sm font-semibold px-4 py-2 rounded-md whitespace-nowrap transition-colors ${FOCUS_RING}`}
            >
              {t('layout.footer.contactCta')}
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
